"use client";

import { storyblokEditable, StoryblokComponent } from "@storyblok/react/rsc";
import { FC, useEffect, useRef, useState } from "react";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Container } from "@/components/layout/container";
import { LegalPageStoryblok } from "@/types/sb-component-types";
import { useScopedI18n } from "@/locales/client";
interface ILegalPageProps {
  blok: LegalPageStoryblok;
}
const LegalPage: FC<ILegalPageProps> = ({
  blok
}) => {
  const [headings, setHeadings] = useState<HTMLHeadingElement[]>([]);
  const contentRef = useRef<HTMLDivElement>(null);
  const t = useScopedI18n("legalPage");
  useEffect(() => {
    if (contentRef.current) {
      const headingElements = contentRef.current.querySelectorAll("h2, h3");
      setHeadings(Array.from(headingElements) as HTMLHeadingElement[]);
    }
  }, []);
  const scrollToHeading = (heading: HTMLHeadingElement) => {
    const yOffset = -96;
    const y = heading.getBoundingClientRect().top + window.scrollY + yOffset;
    window.scrollTo({
      top: y,
      behavior: "smooth"
    });
  };
  return <Container {...storyblokEditable(blok)} className="mt-[60px] py-12 md:mt-[80px]" data-sentry-element="Container" data-sentry-component="LegalPage" data-sentry-source-file="LegalPage.tsx">
      <div className="flex flex-col gap-8 lg:flex-row">
        <div className="hidden lg:block lg:w-1/4">
          <div className="sticky top-32">
            <h2 className="mb-4 text-xl font-semibold">
              {t("tableOfContents")}
            </h2>
            <ScrollArea data-sentry-element="ScrollArea" data-sentry-source-file="LegalPage.tsx">
              <nav>
                <ul className="space-y-2">
                  {headings.map(heading => <li key={heading.id}>
                      <button className="w-full rounded px-4 py-2 text-left text-sm text-slate-600 transition-colors hover:bg-slate-100 hover:text-slate-900" style={{
                    paddingLeft: `${heading.nodeName === "H3" ? "1rem" : "0"}`
                  }} onClick={() => scrollToHeading(heading)}>
                        {heading.textContent}
                      </button>
                    </li>)}
                </ul>
              </nav>
            </ScrollArea>
          </div>
        </div>
        <div className="lg:w-3/4">
          <h1 className="mb-8 text-4xl font-bold">{blok.title}</h1>
          <div ref={contentRef} className="max-w-none">
            {blok.content?.map(nestedBlok => <StoryblokComponent key={nestedBlok._uid} blok={nestedBlok} />)}
          </div>
        </div>
      </div>
    </Container>;
};
export default LegalPage;